import { linePlot, periodInput } from "../definitionHelpers";
import { PALETTE } from "../palette";
import { MA_TYPE, PRICE_SOURCE } from "../indicatorTypes";
import { priceReader } from "../math/priceSources";
import { fillMovingAverage } from "../math/movingAverages";

/**
 * Bears Power (research §1.4). Not in TradingView, the classic MetaTrader
 * formula: the low of the bar minus the EMA of the close over Period (the EMA
 * starts as in TV, from the SMA of the first window).
 */
export default {
  id: "bears-power",
  name: "Bears Power",
  isOscillator: true,
  inputs: [
    periodInput("period", "Period", 13),
  ],
  plots: [
    linePlot("value", "Main Line", PALETTE.LIME),
  ],
  buffers: ["ema"],
  levels: [],

  calculate: (bars, { period }, series, fromIndex) => {
    fillMovingAverage({
      type: MA_TYPE.EMA,
      read: priceReader(bars, PRICE_SOURCE.CLOSE),
      target: series.ema,
      period,
      fromIndex,
      toIndex: bars.length,
    });

    for (let index = fromIndex; index < bars.length; index += 1) {
      series.value[index] = bars[index].low - series.ema[index];
    }
  },
};
